/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { GetSubItemsArgs, SubItem } from './types';
import { apiClient } from '@/utils/apiClient';

export const fetchProductSubitems = createAsyncThunk<
  SubItem[],
  GetSubItemsArgs,
  { rejectValue: string }
>('products/fetchSubitems', async ({ item_id }, { rejectWithValue }) => {
  try {
    const qs = `?item_id=${encodeURIComponent(item_id)}`;
    const resp = await apiClient(`/data/api/v1/products/subitems/${qs}`, {
      method: 'GET',
    });
    return resp as SubItem[];
  } catch (err: any) {
    return rejectWithValue(err?.message || 'Failed to load subitems');
  }
});
